import React from 'react';
import './ThankYouPage.scss'; // Import the SCSS module

const ThankYouPage2 = () => {
  return (
    <div className="thank-you-page">
      <div className="thank-you-content">
        <img src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2Fheart.png?alt=media&token=9bac356a-789f-4d43-bdc3-be2a6d8e9904" alt="Heart Icon" className="heart-icon" />
        <h1>Thank You!</h1>
        <p>Your message has been successfully sent. We will get back to you as soon as possible.</p>
        <button onClick={() => window.location.href = '/'}>Return to Home</button>
      </div>
    </div>
  );
};

export default ThankYouPage2;
